import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-full text-14px capitalized font-semibold px-2 py-0 max-w-max",
  style: {"color":"#786b59","background":"#fdf3e7"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-4 flex flex-col gap-y-5" }, {
    default: _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        fontSize: "16",
        class: "w-full",
        label: _ctx.$t('dexAssessment.notesFromCS'),
        value: _ctx.data.daRemarksL2
      }, null, 8, ["label", "value"]),
      (_ctx.data.daNeedToRTS)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("dexAssessment.processRTS")), 1))
        : _createCommentVNode("", true),
      _hoisted_2,
      _createVNode(_component_DataWrapper, {
        fontSize: "16",
        class: "w-full",
        label: _ctx.$t('dexAssessment.disputeRejectNotesFromCS'),
        value: _ctx.data.daRemarksL2Dispute
      }, null, 8, ["label", "value"])
    ]),
    _: 1
  }))
}